var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { communicationChartChannelKey } from '@web/components/CommunicationNetworkGraph/components/communicationChartI18n';
import { CommunicationChartChatLineSwatch, CommunicationChartDirectionSwatch, CommunicationChartMeetLineSwatch, CommunicationChartTrendLineSwatch, CommunicationChartVolumeSwatch } from '@web/components/CommunicationNetworkGraph/components/CommunicationChartLegendSwatches';
import { isCommunicationChartChatChannel, isCommunicationChartEmailChannel, isCommunicationChartMeetChannel } from '@web/components/CommunicationNetworkGraph/core/communicationChart/types';
import { COMMUNICATION_CHART_COLORS } from '@web/components/CommunicationNetworkGraph/graph/communicationChartConstants';
var LEGEND_I18N_BASE = 'app.dashboard.communicationChart.legend';
var LEGEND_SHARED_PREFIX = "".concat(LEGEND_I18N_BASE, ".shared");
var buildInlineChannelLegendConfig = function (compact, channelTrendColor, descriptionParagraphKeys) { return ({
    layout: 'inline',
    compact: compact,
    extended: buildTrendExtendedEntries(channelTrendColor),
    descriptionParagraphKeys: descriptionParagraphKeys
}); };
var buildTrendExtendedEntries = function (channelTrendColor) { return [
    {
        id: 'trendUp',
        labelKey: "".concat(LEGEND_SHARED_PREFIX, ".trendUp"),
        swatch: _jsx(CommunicationChartTrendLineSwatch, { color: channelTrendColor })
    },
    {
        id: 'trendDown',
        labelKey: "".concat(LEGEND_SHARED_PREFIX, ".trendDown"),
        swatch: (_jsx(CommunicationChartTrendLineSwatch, { color: COMMUNICATION_CHART_COLORS.linkTrendDown }))
    },
    {
        id: 'trendUnchanged',
        labelKey: "".concat(LEGEND_SHARED_PREFIX, ".trendUnchanged"),
        swatch: (_jsx(CommunicationChartTrendLineSwatch, { color: COMMUNICATION_CHART_COLORS.linkTrendUnchanged }))
    },
    {
        id: 'trendNew',
        labelKey: "".concat(LEGEND_SHARED_PREFIX, ".trendNew"),
        swatch: (_jsx(CommunicationChartTrendLineSwatch, { color: channelTrendColor, dashed: true }))
    }
]; };
export var buildCommunicationChartLegendConfig = function (_a) {
    var channel = _a.channel;
    var channelTrendColor = COMMUNICATION_CHART_COLORS.linkTrendUp;
    var isChat = isCommunicationChartChatChannel(channel);
    var isEmail = isCommunicationChartEmailChannel(channel);
    var isMeet = isCommunicationChartMeetChannel(channel);
    var inlineChannelKey = isChat
        ? 'chat'
        : isEmail
            ? 'email'
            : isMeet
                ? 'meet'
                : null;
    var inlineChannelPrefix = inlineChannelKey != null ? "".concat(LEGEND_I18N_BASE, ".").concat(inlineChannelKey) : null;
    var selectedLineEntry = {
        id: "".concat(channel, "Line"),
        labelKey: communicationChartChannelKey(channel),
        swatch: isCommunicationChartMeetChannel(channel) ? (_jsx(CommunicationChartMeetLineSwatch, { lineColor: channelTrendColor })) : (_jsx(CommunicationChartChatLineSwatch, { lineColor: channelTrendColor }))
    };
    var compact = __spreadArray([
        selectedLineEntry,
        {
            id: 'volume',
            labelKey: inlineChannelPrefix
                ? "".concat(inlineChannelPrefix, ".volume")
                : "".concat(LEGEND_I18N_BASE, ".volume"),
            swatch: _jsx(CommunicationChartVolumeSwatch, {})
        }
    ], (isCommunicationChartMeetChannel(channel)
        ? []
        : [
            {
                id: 'direction',
                labelKey: "".concat(LEGEND_SHARED_PREFIX, ".direction"),
                swatch: _jsx(CommunicationChartDirectionSwatch, {})
            }
        ]), true);
    if (inlineChannelPrefix == null) {
        return {
            layout: 'inline',
            compact: compact,
            extended: buildTrendExtendedEntries(channelTrendColor)
        };
    }
    var descriptionParagraphKeys = isMeet
        ? [
            "".concat(inlineChannelPrefix, ".description.thickness"),
            "".concat(LEGEND_SHARED_PREFIX, ".description.colour")
        ]
        : [
            "".concat(inlineChannelPrefix, ".description.thickness"),
            "".concat(LEGEND_SHARED_PREFIX, ".description.arrow"),
            "".concat(LEGEND_SHARED_PREFIX, ".description.colour")
        ];
    return buildInlineChannelLegendConfig(compact, channelTrendColor, descriptionParagraphKeys);
};
